import { Flex, ModalBody, Spinner, Text } from "@chakra-ui/react";
import { Modal } from "components";

export default function Loading({ text = 'Carregando dados...', ...props }){
    return(
    <Modal size="3xl" {...props}>
        <ModalBody>
            <Flex direction="column" alignItems="center" justifyContent="center" py={8}>
                <Spinner size="xl" mb={4} color="orange" />
                <Text color="GrayText" children={text} />
            </Flex>
        </ModalBody>
    </Modal>
    )
}